// Module
var code = "<div class=\"gc-beacon {{ beacon.class }}\" @click=\"beacon.onClick($event)\"></div>";
// Exports
export default code;